export default __webpack_public_path__ + "static/blog4-9a27ccd88a2f5d2412ea5387e9e3345b.png";